import React, { useState } from 'react';
import { ReportHeader } from '../../header/report-header';
import { StudentCourseByStatusSideBarFilter } from './side-bar-filter/student-course-by-status-side-bar-filter';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { getStudentCourseByStatusOperation } from './operations/get-student-course-by-status-operation';
import { StudentCourseByStatusFilters } from './side-bar-filter/student-course-by-status-side-bar-filter.type';
import { StudentStatusInCourseReportResultDb } from '../../../../api/types/reports/student-status-in-course/student-status-in-course-report-result-db';
import { CourseStatus } from '../../../../api/types/programs/course/course-status';
import { Tag } from 'primereact/tag';

export const ReportStudentCourseByStatus = () => {
  const [data, setData] = useState<StudentStatusInCourseReportResultDb[]>([]);

  const [loading, setLoading] = useState(false);

  const handleSearch = async (filters: StudentCourseByStatusFilters) => {
    await getStudentCourseByStatusOperation(filters, setLoading, setData);
  };

  const getStatusDetails = (status) => {
    switch (status) {
      case CourseStatus.INIT:
        return {
          label: 'טרם החל',
          severity: 'info',
          icon: 'pi pi-clock',
        };
      case CourseStatus.ACTIVE:
        return {
          label: 'פעיל',
          severity: 'success',
          icon: 'pi pi-check-circle',
        };
      case CourseStatus.CLOSED:
        return {
          label: 'סגור',
          severity: 'warning',
          icon: 'pi pi-times-circle',
        };
      case CourseStatus.FINISHED:
        return {
          label: 'הושלם',
          severity: 'secondary',
          icon: 'pi pi-flag',
        };
      default:
        return {
          label: 'לא ידוע',
          severity: 'danger',
          icon: 'pi pi-question-circle',
        };
    }
  };

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: '20px' }}>
      <ReportHeader
        title="דו״ח סטטוס סטודנטים בקורס"
        description="דו״ח זה מציג מידע על סטטוס הקורסים של הסטודנטים בתוכניות הלימודים השונות"
        metadata={[
          { label: 'מטרת הדו״ח', value: 'מעקב אחר התקדמות סטודנטים בקורסים' },
          { label: 'תדירות עדכון', value: 'יומי' },
        ]}
        category="education"
      />

      <div style={{ display: 'flex', gap: '20px' }}>
        <div
          style={{
            height: 'calc(100vh - 230px)',
            minHeight: '100%',
            width: '300px',
            minWidth: '250px',
          }}
        >
          <StudentCourseByStatusSideBarFilter onSearch={handleSearch} />
        </div>

        <div
          style={{
            flex: 1,
            backgroundColor: 'white',
            borderRadius: '8px',
            padding: '16px',
          }}
        >
          <DataTable
            value={data}
            loading={loading}
            rows={10}
            rowsPerPageOptions={[10, 25, 50]}
            emptyMessage="לא נמצאו נתונים"
            style={{ direction: 'rtl' }}
          >
            <Column
              field="branchName"
              header="שלוחה"
              sortable
              style={{ textAlign: 'right' }}
            />
            <Column
              field="firstName"
              header="שם פרטי"
              sortable
              style={{ textAlign: 'right' }}
            />
            <Column
              field="lastName"
              header="שם משפחה"
              sortable
              style={{ textAlign: 'right' }}
            />
            {/*            <Column
              field="nationalId"
              header="ת.ז"
              sortable
              style={{ textAlign: 'right' }}
            />*/}
            {/*            <Column
              field="phoneNumber"
              header="טלפון נייד"
              style={{ textAlign: 'right' }}
            />*/}
            <Column
              field="abstractProgramName"
              header="תוכנית לימודים"
              sortable
              style={{ textAlign: 'right' }}
            />
            <Column
              field="programStartYear"
              style={{ textAlign: 'right' }}
              header="שנת התחלה"
              sortable
            />
            <Column
              field="annualSerialProgramNumber"
              header="מספר סידורי שנתי"
              style={{ textAlign: 'right' }}
              body={(rowData) => (
                <label>{rowData.annualSerialProgramNumber + 1}</label>
              )}
            />

            {/*<Column
              field="programStatus"
              header="סטטוס בתוכנית לימודים"
              style={{ textAlign: 'right' }}
              body={(rowData) => {
                const statusDetails = getStatusDetails(rowData.status);
                return (
                  <Tag
                    value={statusDetails.label}
                    severity={statusDetails.severity}
                    icon={statusDetails.icon}
                    style={{
                      textAlign: 'right',
                      direction: 'rtl',
                      width: '100px',
                    }}
                  />
                );
              }}
              sortable
            />*/}
            <Column
              style={{ textAlign: 'right' }}
              field="courseName"
              header="שם קורס"
              sortable
            />

            <Column
              field="status"
              header="סטטוס קורס"
              style={{ textAlign: 'right' }}
              body={(rowData) => {
                const statusDetails = getStatusDetails(rowData.courseStatus);
                return (
                  <Tag
                    value={statusDetails.label}
                    severity={statusDetails.severity}
                    icon={statusDetails.icon}
                    style={{
                      textAlign: 'right',
                      direction: 'rtl',
                      width: '100px',
                    }}
                  />
                );
              }}
              sortable
            />
            <Column
              field="studentCourseStatusName"
              header="סטטוס סטודנט בקורס"
              sortable
              style={{ textAlign: 'right' }}
            />
          </DataTable>
        </div>
      </div>
    </div>
  );
};
